import { isSupported } from 'firebase/messaging';

import detectBrowser from '~/libs/detectBrowser';

const notSupportBrowser = ['firefox'];

const checkFCMSupport = async () => {
    const browser = detectBrowser();
    if (!browser) return false;

    // 브라우저 지원 여부 확인
    const browserName = browser.name;
    if (notSupportBrowser.includes(browserName)) {
        return false;
    }

    return await isSupported();
};

export default checkFCMSupport;
